import { AccountsUserAccountType } from '../users/__generated__/UserSessionContextAtomQuery.graphql';

export enum ElevateAccountTypes {
  Internal = 'internal',
  Employer = 'employer',
  Contractor = 'contractor',
  Supplier = 'supplier',
}

export function fromAccountsUserAccountType(accountType: AccountsUserAccountType): ElevateAccountTypes {
  switch (accountType) {
    case 'EMPLOYER':
      return ElevateAccountTypes.Employer;
    case 'CANDIDATE':
      return ElevateAccountTypes.Contractor;
    case 'INTERNAL':
      return ElevateAccountTypes.Internal;
  }
  throw Error(`Unknown Account Type: ${accountType}`);
}

export const elevateAccountTypesList: Array<{
  id: string;
  name: string;
}> = [
  {
    id: ElevateAccountTypes.Employer,
    name: 'Employer',
  },
  {
    id: ElevateAccountTypes.Contractor,
    name: 'Contractor',
  },
  {
    id: ElevateAccountTypes.Internal,
    name: 'Internal',
  },
];
